import * as React from 'react';
import { useCallback } from 'react';
import { TextField, ITextFieldStyles } from '@fluentui/react/lib/TextField';
import { gridSubUnit, gridUnit } from '@uifabric/portal-ux/lib/styling/stylingConstants';
import { useLocalization } from '@microsoft/portal-app/lib/shared/localization';
import { ContactPreferenceEmailError } from '../models';

export interface IContactPreferenceEmailInput {
  disabled?: boolean;
  error?: ContactPreferenceEmailError;
  value?: string;
  onChange?: (value: string) => void;
}

export const ContactPreferenceEmailInput = ({
  disabled,
  error,
  value,
  onChange
}: IContactPreferenceEmailInput): React.ReactElement | null => {
  const [t] = useLocalization('Privacy');
  const handleChange = useCallback(
    (_: any, value = '') => {
      onChange?.(value);
    },
    [onChange]
  );

  return (
    <TextField
      styles={styles}
      underlined
      disabled={disabled}
      placeholder={'john@contoso.com'}
      errorMessage={error ? t(error) : undefined}
      value={value}
      onChange={handleChange}
    />
  );
};

const styles: Partial<ITextFieldStyles> = {
  root: {
    margin: `${gridSubUnit * 5}px 0`,
    maxWidth: `${gridUnit * 40}px`,
    width: '100%'
  }
};
